<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Manage Storage Types</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <div class="modal-card-body has-text-centered">

          <article 
            v-if="!loading && storageTypes.length == 0" 
            class="message is-info is-fullwidth mt-3">
            <div class="message-body">
              There are no storage types
            </div>
          </article>

          <!-- existing storage types -->
          <div 
            class="panel mt-3" 
            v-if="!loading && storageTypes.length > 0">
            <a class="panel-block" 
              v-for="storageType in storageTypes"
              :key="storageType.id">
              <div class="row-justified is-fullwidth">

                <div v-if="storageType.id != editingId">
                  {{ storageType.storage_type_name }}
                </div>
                <v-text-field 
                  v-else
                  required
                  placeholder="Enter Storage Type Name"
                  v-model="storageType.storage_type_name"
                  @blur="updateStorageType({ 
                    storageTypeId: storageType.id, 
                    data: { storage_type_name: $event }
                  })"/>

                <div class="buttons">
                  <button 
                    @click="toggleEdit(storageType.id)"
                    class="button is-small">
                    <span class="icon">
                      <i class="fas fa-edit has-text-grey"></i>
                    </span>
                  </button>
                  <button 
                    @click="launchConfirmDelete(storageType.id)"
                    class="button is-small">
                    <span class="icon">
                      <i class="fas fa-trash has-text-grey"></i>
                    </span>
                  </button>
                </div>

              </div>
            </a>
          </div>

          <!-- adding new storage type -->
          <div v-if="adding">
            <v-form :valid.sync="valid" class="pb-2">
              <v-text-field 
                required
                placeholder="Enter storage type"
                v-model="newStorageType"/>
            </v-form>

            <div class="buttons">
              <button 
                :disabled="!valid"
                @click="addNew()"
                class="button is-primary is-small">
                <span class="icon">
                  <i class="fas fa-save"></i>
                </span>
                <span>Save new Storage Type</span>
              </button>
              <button 
                @click="adding = false"
                class="button is-small">
                <span class="icon">
                  <i class="fas fa-times has-text-grey"></i>
                </span>
                <span>Exit Add Storage Type</span>
              </button>
            </div>
          </div>

          <button 
            v-if="!adding"
            class="button is-primary is-small" 
            @click="adding = true; editingId = null">
            Add a Storage Type
          </button>

        </div>

      </div>

      <v-confirm-modal 
        v-model="confirmDelete.state"
        :title="confirmDelete.title"
        :message="confirmDelete.message"
        :type="confirmDelete.type"
        @confirm="deleteConfirmedCb()"
        @cancel="confirmDelete.state = false"/>

    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'
import VConfirmModal from '@/components/base/VConfirmModal'
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { VTextField, VForm, VConfirmModal },
  data() {
    return {
      valid: false,
      newStorageType: null,
      adding: false,
      editingId: null,
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this storage type? This will affect all the existing storage using this storage type',
        type: 'danger'
      },
      deleteConfirmedCb: null,
    }
  },
  computed: {
    ...mapState("storageTypes", ["storageTypes", "loading"])
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("storageTypes", [
      "getStorageTypes", "addStorageType", 
      "updateStorageType", "deleteStorageType"
    ]),
    initialize() {
      if (this.storageTypes.length == 0) {
        this.getStorageTypes();
      }
    },
    addNew() {
      this.addStorageType({ 
        storage_type_name: this.newStorageType
      }).then(() => {
        this.newStorageType = null;
        this.adding = false;
      });
    },
    toggleEdit(id) {
      if (this.editingId == id) {
        this.editingId = null;
      } else {
        this.editingId = id;
      }
    },
    launchConfirmDelete(storageTypeId) {
      this.deleteConfirmedCb = () => {
        this.deleteStorageType(storageTypeId);
        this.confirmDelete.state = false;
      }
      this.confirmDelete.state = true;
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
.row-justified {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
}

.modal-card {
  border-radius: 6px;
}
</style>